import { useEffect, useRef } from 'react'
import Plotly from 'plotly.js-dist-min'

// Accepts either a `spec` object ({ data, layout }) from the AI create_chart tool,
// or raw `data` / `layout` props for manual use.
export default function PlotlyChart({ spec, data, layout, config, style }) {
  const ref = useRef(null)
  const resolvedData   = spec?.data   ?? data   ?? []
  const resolvedLayout = spec?.layout ?? layout ?? {}

  useEffect(() => {
    if (!ref.current) return
    // Plotly's default title font (15px) is larger than the body font (11px) and
    // can overflow narrow dashboard cards, getting clipped on both edges by the
    // SVG's overflow:hidden. Cap it to a size that fits compact containers.
    const { title, ...restLayout } = resolvedLayout
    const normalizedTitle = title == null
      ? title
      : typeof title === 'string'
        ? { text: title, font: { size: 12 } }
        : { ...title, font: { size: 12, ...title.font } }
    Plotly.react(
      ref.current,
      resolvedData,
      {
        autosize: true,
        ...restLayout,
        ...(normalizedTitle != null ? { title: normalizedTitle } : {}),
      },
      config ?? { displayModeBar: false, responsive: true },
    )
  }, [resolvedData, resolvedLayout, config])

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const ro = new ResizeObserver(() => Plotly.Plots.resize(el))
    ro.observe(el)
    return () => ro.disconnect()
  }, [])

  if (!resolvedData.length) return null
  return <div ref={ref} style={{ width: '100%', minHeight: 260, ...style }} />
}
